var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":"默认格式"}},[_c('el-select',{model:{value:(_vm.activeValue),callback:function ($$v) {_vm.activeValue=$$v},expression:"activeValue"}},_vm._l((_vm.formats),function(item){return _c('el-option',_vm._b({key:item.value},'el-option',item,false))}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }